import { Money } from '@cash-web/protos/squareup/common/currency.pb'
import { CurrencyCode } from '@cash-web/protos/squareup/common/currency_codes.pb'

type FormatMoneyOptions = { hideDecimalsIfNoCents?: boolean }

export const formatMoney = (
  { amount = 0, currency_code = CurrencyCode.USD }: Money,
  { hideDecimalsIfNoCents = false }: FormatMoneyOptions = {}
) => {
  const decimalAmount = amount * 0.01
  const hasCents = amount % 100 !== 0

  const options: Intl.NumberFormatOptions = {
    style: 'currency',
    maximumFractionDigits: hideDecimalsIfNoCents && !hasCents ? 0 : 2,
    currency: currency_code,
  }
  return new Intl.NumberFormat('en-US', options).format(decimalAmount)
}
